<template>
    <article class="mobile-question-card">
        <div class="mobile-question-card__user">
            <img :src="avatar" alt="">
            <div>
                <strong>{{ author }}</strong>
                <span>{{ createdDate }}</span>
            </div>
            <em v-if="question.status === 100">已解决</em>
            <em v-else class="mobile-question-card__pending">待解答</em>
        </div>

        <router-link :to="detailPath" class="mobile-question-card__main">
            <div class="mobile-question-card__copy">
                <h2>{{ question.title }}</h2>
                <p>{{ excerpt }}</p>
            </div>
            <img v-if="question.thumb" class="mobile-question-card__thumb" :src="question.thumb" alt="">
        </router-link>

        <div class="mobile-question-card__footer">
            <span class="mobile-question-card__tag">{{ typeTitle }}</span>
            <span>{{ replyCount }} 回答</span>
            <span>{{ viewCount }} 浏览</span>
        </div>
    </article>
</template>

<script>
import {formatTime, stripHtmlTag} from '@/utils/tools';

export default {
    name: 'MobileQuestionCard',
    props: {
        question: {
            type: Object,
            required: true,
        },
    },
    computed: {
        detailPath() {
            return `/wenda/detail/${this.question.answer_id}.html`;
        },
        avatar() {
            return this.question.username && this.question.username.face || '/static/bbs/images/answer/face.png';
        },
        author() {
            const user = this.question.username || {};
            return user.nickname || user.username || 'BIGEMAP 用户';
        },
        createdDate() {
            return formatTime(this.question.create_time, 'Y-m-d');
        },
        excerpt() {
            if (!this.question.content) {
                return '点击查看问题详情';
            }
            return stripHtmlTag(this.question.content).trim();
        },
        typeTitle() {
            const mapping = {
                100: 'BIGEMAP PRO',
                200: 'BIGEMAP SERVER',
                300: 'BIGEMAP APP',
            };
            return mapping[this.question.type_id] || '产品问答';
        },
        replyCount() {
            return this.question.sum && this.question.sum.reply || 0;
        },
        viewCount() {
            return this.question.sum && this.question.sum.view || 0;
        },
    },
};
</script>

<style scoped lang="less">
.mobile-question-card {
    padding: 17px 16px;
    margin-bottom: 10px;
    background: #fff;
    border: 1px solid #e9edf3;
    border-radius: 8px;
}

.mobile-question-card__user {
    display: flex;
    align-items: center;

    > img {
        width: 32px;
        height: 32px;
        object-fit: cover;
        border-radius: 50%;
        border: 1px solid #e7ebf1;
    }

    > div {
        display: flex;
        min-width: 0;
        margin-left: 9px;
        flex: 1;
        flex-direction: column;

        strong {
            overflow: hidden;
            color: #4b576b;
            font-size: 13px;
            font-weight: 500;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        span {
            margin-top: 2px;
            color: #a0a9b8;
            font-size: 12px;
        }
    }

    em {
        padding: 3px 7px;
        color: #239765;
        font-size: 12px;
        font-style: normal;
        background: #eaf8f1;
        border-radius: 3px;
    }

    .mobile-question-card__pending {
        color: #d78825;
        background: #fff5e8;
    }
}

.mobile-question-card__main {
    display: flex;
    padding: 14px 0 13px;
    gap: 12px;
    color: inherit;
    text-decoration: none;
}

.mobile-question-card__copy {
    min-width: 0;
    flex: 1;

    h2 {
        display: -webkit-box;
        margin: 0;
        overflow: hidden;
        color: #202a3b;
        font-size: 18px;
        font-weight: 600;
        line-height: 26px;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    p {
        display: -webkit-box;
        margin: 7px 0 0;
        overflow: hidden;
        color: #758095;
        font-size: 14px;
        line-height: 22px;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
}

.mobile-question-card__thumb {
    width: 80px;
    height: 66px;
    flex-shrink: 0;
    object-fit: cover;
    border-radius: 5px;
}

.mobile-question-card__footer {
    display: flex;
    min-height: 22px;
    align-items: center;
    gap: 12px;
    color: #98a2b3;
    font-size: 12px;
}

.mobile-question-card__tag {
    max-width: 45%;
    padding: 3px 8px;
    overflow: hidden;
    color: #2478f2;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #edf4ff;
    border-radius: 3px;
}
</style>
